<div class="box sepa-input-box" [formGroup]="sepaFormGroup">
  <h3>Wie lautet Ihre IBAN?</h3>
  <p>Zum Schluss benötigen wir noch Ihre Bankverbindung.</p>

  <ez-iban-input name="iban" controlName="iban"> </ez-iban-input>

  <div class="checkbox-and-info-container">
    <ez-checkbox-input name="sepa-mandate" controlName="givesSepaMandate">
      <span class="text--bold"> SEPA-Lastschriftmandat erteilen </span>
    </ez-checkbox-input>
    <ez-info-popover
      info
      #sepaInfo
      style="display: inline"
      popoverText="Im Zuge des einheitlichen Euro-Zahlungsverkehrs (SEPA) gibt es für jeden Zahlungsempfänger eine
        Gläubiger-Identifikationsnummer. Zusammen mit der Mandatsreferenz, die wir Ihnen gesondert mitteilen, ist eine
        eindeutige Identifizierung des (SEPA-)Lastschriftmandats gegeben. Unsere Gläubiger-Identifikationsnummer
        (CI/Creditor Identifier) für die {{ organisationName }} lautet: {{ creditorId }}."
    />
  </div>
  <p>
    Ich ermächtige Sie, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein
    Kreditinstitut an, die von Ihnen auf mein Konto bezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb von
    acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrags verlangen. Es gelten dabei die
    mit meinem Kreditinstitut vereinbarten Bedingungen. Vor der SEPA-Lastschrift informiert der Zahlungsempfänger über
    Abbuchungstermin und Betrag. Ich möchte meine Angaben elektronisch übermitteln und verzichte daher auf ein
    schriftliches SEPA-Mandat.
  </p>

  <ez-button label="Zahlungsdaten senden" (buttonClick)="onSubmit()" [disabled]="sepaFormGroup.invalid"></ez-button>
  @if (errorMessage(); as message) {
    <span class="error-message">{{ message }}</span>
  }

  <ez-button
    theme="secondary"
    label="Zurück zur Zahlungsübersicht"
    buttonType="button"
    (buttonClick)="onBackToOverview()"
  ></ez-button>
</div>
